import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import "@fontsource/open-sans"; // Defaults to weight 400
import "@fontsource/open-sans/400.css"; // Specify weight
import "@fontsource/open-sans/400-italic.css"; // Specify weight and style

import "@fontsource/caveat"; // Defaults to weight 400
import "@fontsource/caveat/400.css"; // Specify weight

import { ToastContainer, toast } from "react-toastify";
import apilink from "../globals/Baseurls";
import axios from "axios";
import { Squares } from "react-activity";
import "react-activity/dist/library.css";

import InstallButton from "./InstallButton";


const Login = () => {

  const [searchTerm, setSearchTerm] = useState("");
  const [posting, setPosting] = useState(false);
  const navigate = useNavigate();

  const handleSignIn = () => {

    if (searchTerm == "") {
      toast.warn("Proceeding failed. Fill in the missing family code", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    setPosting(true);
    const dataObj = {
      familycode: searchTerm
    };

    const baseUrl = apilink.link;
    axios
      .post(`${baseUrl}/family/codesignin`, dataObj)
      .then((response) => {
        if (response.data.message === "Successfull") {
          setPosting(false);
          setSearchTerm("");
          const user = response.data;
          console.log(user);
          localStorage.setItem("userFamilyData", JSON.stringify(user));
          localStorage.setItem("userFamilyLevel", response.data.level.toString());
          navigate("/app/home");
          return;
        } else {
          setPosting(false);
          toast.warn(response.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          return;
        }
      })
      .catch((err) => {
        console.log(err);
        console.log("Error creating post");
      });
    
  }
  const handleAdminSignIn = () => {
    navigate("/signin");
  }

  const onSearchInput = (e) => {
    setSearchTerm(e.target.value);
  };
  return (
    <>
      <div
        style={{
          flexDirection: "column",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "76px",
          paddingInline: 30,
        }}
      >
        <img
          alt="logo"
          style={{ width: "100px", height: "80px", resizeMode: "stretch" }}
          src={require("./pic1.webp")}
        />
        <h1
          className="navbar-brand mb-0"
          style={{ fontFamily: "Caveat", fontSize: 20 }}
        >
          family<b>Tree</b>
        </h1>
        <p
          style={{
            color: "#779d38",
            fontFamily: "Open Sans",
            marginTop: "80px",
          }}
        >
          Sign In
        </p>
        <span style={{ fontFamily: "Open Sans", fontSize: 12 }}>
          Enter the family tree number and hit proceed button
        </span>
        <input
          style={{
            width: "320px",
            borderWidth: 1,
            borderColor: "#779d38",
            borderRadius: 5,
            height: 50,
            fontFamily: "Open Sans",
            fontSize: 24,
            paddingInline: 10,
            marginBottom: "10px",
          }}
          value={searchTerm}
          onChange={onSearchInput}
          type="number"
          maxlength={6}
        />
        <button
          onClick={() => handleSignIn()}
          style={{
            width: "320px",
            backgroundColor: "#779d38",
            borderRadius: 5,
            border: "none",
            height: 50,
            fontFamily: "Open Sans",
            fontSize: 14,
            color: "white",
            marginTop: "10px",
          }}
        >
           {posting === false && <>Proceed</>}
          {posting && (
            <>
              <Squares />
            </>
          )}
        </button>
          <InstallButton />
        <p
          onClick={() => handleAdminSignIn()}
          style={{
            color: "#000000",
            fontFamily: "Open Sans",
            fontSize: 14,
            marginTop: "30px",
            alignSelf: "left",
            width: "320px",
          }}
        >
          Family admin <span style={{color: "#779d38"}}>Sign In</span>
        </p>
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </div>
    </>
  );
};

export default Login;
